<div class="pagination-container">
  <div class="entries-info">
    {{'COMMON.SHOWING' | translate}} {{ start }} {{'COMMON.TO' | translate}} {{ end }} {{'COMMON.OF' | translate}} {{ totalItems | number}} {{'COMMON.ENTRIES' | translate}}
  </div>
  <div class="buttons">
    <button class="nav-arrow" (click)="goToPage(1)" [disabled]="currentPage === 1">
      <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.16667 9.16536L1 4.9987L5.16667 0.832031M11 9.16536L6.83333 4.9987L11 0.832031" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button class="nav-arrow" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
      <svg class="previous-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8332 7.0013H1.1665M1.1665 7.0013L6.99984 12.8346M1.1665 7.0013L6.99984 1.16797" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <ng-container *ngFor="let page of pages">
      <button
        class="pagination-number"
        (click)="goToPage(page)"
        [class.active]="page === currentPage"
      >
        {{ page }}
      </button>
    </ng-container>

    <button class="nav-arrow" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
      <svg class="next-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.1665 7.0013H12.8332M12.8332 7.0013L6.99984 1.16797M12.8332 7.0013L6.99984 12.8346" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button class="nav-arrow" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">
      <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.83333 0.834636L11 5.0013L6.83333 9.16797M1 0.834636L5.16667 5.0013L1 9.16797" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <input
        type="number"
        [(ngModel)]="goToPageInput"
        min="1"
        [max]="totalPages"
        class="go-input"
    />
    <button class="go-button" (click)="goToEnteredPage()">{{'GO' | translate}}</button>
  </div>
</div>
